import { IStaffType } from "@/api";

import { useStaffTypeByKey } from "./hooks";

export function StaffTypeName({ staffTypeKey }: { staffTypeKey: IStaffType["key"] | undefined }) {
  const staffType = useStaffTypeByKey(staffTypeKey);
  return <>{staffType?.name}</>;
}
